import pluralize from "pluralize";

export type DeliveryItemT = {
  id: number;
  delivery_fulfillment_id: number;
  delivery_id: number;
  delivery_name: string;
  license_end_date: string;
  group_name: string;
  volume_upgrade_scheduled?: boolean;
};

type GroupedDataT = {
  [key: string]: DeliveryItemT[];
};

type FlatDataT = DeliveryItemT[];

export type DeliveriesAPIResponseT = {
  data: GroupedDataT | FlatDataT;
};

export type AutoSizerPropsT = {
  height: number;
  width: number;
};

export type DeliveryTypeT = "delivery" | "fulfillmentGroup" | "customer";

export const deliveryTypeLabels: Record<DeliveryTypeT, string> = {
  delivery: "Delivery",
  fulfillmentGroup: "Fulfillment Group",
  customer: "Customer",
};

export type RecurringRemovePayload_T = {
  admin_id: number | null;
  dateStart: string;
  delivery_ids: number[];
};

export type DeliveryPayloadT = {
  admin_id: number | null;
  deliveries: Array<{
    ad_hoc_ticket_id?: string;
    is_ad_hoc?: boolean;
    delivery_id: number;
    target_fulfillment_date: string;
    schedule_volume_upgrade: boolean;
    admin_id?: number | null;
    delivery_schedule_id?: number;
  }>;
};

export type RemoveDeliveriesPayloadT = {
  admin_id: number | null;
  delivery_schedule_ids: number[];
};

export type DialogActionsT = "ADD" | "ADD_ONE" | "CHANGE" | "REMOVE";

export interface ScheduleDialogProps {
  onClose: () => void;
  derivedStartDate?: string;
  derivedEndDate?: string;
  action?: DialogActionsT;
  selectedRows?: DeliveryItemT[];
  onSuccessCallback?: (responseData?: any) => void;
  onErrorCallback?: (error: any) => void;
}

export interface RecurringSummaryCountsProps_T {
  selectedItems: number[];
  startDate: string;
  endDate?: string;
  isRemoving?: boolean;
  setIsValidRemoval?: (isValidRemoval: boolean) => void;
}

export type RecurringSummaryCountsPayload_T = {
  dateStart: string;
  dateEnd?: string;
  delivery_ids: number[];
};

export type RecurringRemoveResponse_T = {
  message: string;
};

export type RecurringSummaryCountsResponse_T = {
  count_customers: number;
  count_deliveries: number;
  count_delivery_events: number;
  count_fulfillment_dates: number;
  count_volume_upgrades: number;
};

export const DialogTypesT = {
  NONE: "",
  ADD: "ADD",
  CHANGE: "CHANGE",
  RECURRING: "RECURRING",
  REMOVE: "REMOVE",
  REMOVE_RECURRING: "REMOVE_RECURRING",
} as const;

export type DialogTypeT = (typeof DialogTypesT)[keyof typeof DialogTypesT];

export const DialogActionMessagesT = {
  ADD: "Added successfully.",
  CHANGE: (count: number) =>
    `${count} ${pluralize("delivery", count)} updated successfully.`,
  REMOVE: (count: number) =>
    `${count} ${pluralize("delivery", count)} removed successfully.`,
};
